import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReminderCrudService } from './reminder-crud/reminder-crud.service';
import { ReminderService } from './reminder-service/reminder.service';
import { ReminderManagerComponent } from './reminder-manager/reminder-manager.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgbTabsetModule, NgbDatepickerModule, NgbTimepickerModule, NgbDateAdapter, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { QmPipesModule } from '../components/qm-pipes/qm-pipes.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    NgbTabsetModule,
    NgbTimepickerModule,
    NgbDatepickerModule,
    NgbTooltipModule,
    FormsModule,
    QmPipesModule
  ],
  providers: [
    ReminderCrudService,
    ReminderService
  ],
  declarations: [
    ReminderManagerComponent
  ],
  exports: [
    ReminderManagerComponent
  ]
})
export class ReminderModule { }
